module.exports = __webpack_public_path__ + "assets/img/bodor@2x.886033fc.png";